var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8089 11.1144C14.7023 10.9344 14.4023 10.6544 13.6556 10.7877C13.2423 10.861 12.8223 10.8944 12.4023 10.8744C10.8489 10.8077 9.44228 10.0944 8.46228 8.99438C7.59562 8.02771 7.06228 6.76771 7.05562 5.40771C7.05562 4.64771 7.20228 3.91438 7.50228 3.22105C7.79562 2.54771 7.58895 2.19438 7.44228 2.04771C7.28895 1.89438 6.92895 1.68105 6.22228 1.97438C3.49562 3.12105 1.80895 5.85438 2.00895 8.78105C2.20895 11.5344 4.14228 13.8877 6.70228 14.7744C7.31562 14.9877 7.96228 15.1144 8.62895 15.141C8.73562 15.1477 8.84228 15.1544 8.94895 15.1544C11.1823 15.1544 13.2756 14.101 14.5956 12.3077C15.0423 11.6877 14.9223 11.2944 14.8089 11.1144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon_moon.514bad508435fd3023a1d848b81aec8d.svg";
export { ForwardRef as ReactComponent };